import React from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import styled from 'styled-components'
import { useAuth } from '../context/AuthContext'

const LoadingScreen = styled.div`
  min-height: 100vh;
  display: grid;
  place-items: center;
  font-family: 'Lato', sans-serif;
  color: #1f2937;
`

function ProtectedRoute({ children }) {
  const location = useLocation()
  const { isLoading, isAuthenticated } = useAuth()

  if (isLoading) {
    return <LoadingScreen>Checking admin session...</LoadingScreen>
  }

  if (!isAuthenticated) {
    return <Navigate to="/admin/login" replace state={{ from: location.pathname }} />
  }

  return children
}

export default ProtectedRoute
